export const styles = {
  messagesList: {
    width: '100%',
    transform: 'rotate(180deg)',
    direction: 'rtl',
    display: 'flex',
    justifyContent: 'center',
    overflowY: 'overlay',
    padding: '0 16px',
    WebkitOverflowScrolling: 'touch',
    '&::WebkitScrollbar': {
      width: '6px',
      height: '5px',
    },
    '&::WebkitScrollbarThumb': {
      borderRadius: '10px',
    },
  },
  list: {
    '& > div': {
      maxWidth: '780px',
      width: '100%',
    },
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};
